import React, { Fragment, useContext, useEffect, useState } from 'react';
import { BrowserRouter, NavLink, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { MessageBar, MessageBarType, Shimmer } from "office-ui-fabric-react";
import { ToastContainer, toast } from 'react-toastify';



import { DefaultButton, Spinner, SpinnerSize, Text, TextField } from 'office-ui-fabric-react';




import * as http from '../../http';
import { WsHeader } from '../BaseLayout/Header';
import Loading from '../Shared/Loading';
import { WsDeliverPortalContext } from './DeliverPortalContext';
import { WsAppContext } from '../AppContext';
import { getSocketClient } from '../../socket-client';
import { WsAlertComponent } from '../Alert';
import { version } from '../../config';
import { WsAlert } from '../../core';
import { createEvent, setAuthenticatedUser, WsAnalyticsEventType } from "../../analytics";

import { WsHeaderAdmin} from './HeaderMenu';





import { WsHomePage } from './Pages/Home';
import { WsDecodePage } from './Pages/DecodePage';
import { WsDynamic360Page } from './Pages/Decode/Dynamic360';
import { WsDataBreakdownPage } from './Pages/Decode/DataBreakdownPage';




import { WsAppsPage } from "./Pages/Apps";
import { WsConfigPage } from "./Pages/ConfigPage";
import { WsServicingPage } from "./Pages/Servicing";
import ErrorPage from "../ErrorPage";
import { WsCopilotPage } from "./Pages/Copilot";
import { getJobStatus, getJobTitle, getWorkloadName } from "./data/deliver-data";
import { WsJobPanel } from "./Pages/JobsPage";






import MarkdownPreview from '@uiw/react-markdown-preview';

import '@uiw/react-markdown-preview/markdown.css'; // Default styles

// import '@uiw/react-markdown-preview/themes/github.css'; // Optional theme




import '../Portal.scss';

import { wiki } from "../../wiki";
import { PiArrowsClockwiseBold } from "react-icons/pi";
import { WsDocumentationPage } from "../DocumentationPage";
import { WsAidaPage } from "./Pages/AidaPage";
import { WsAiHubPage } from "../AiHub/AiHubPage";
import { MantineProvider } from "@mantine/core";




// Variables

let socketClientCurrentUser: any | undefined = undefined;




// Helper Functions

const socketPing = async (socket: SocketIOClient.Socket) => {

  socket.emit('wsp:ping', {
    email: socketClientCurrentUser ? socketClientCurrentUser.email : '',
    version
  });

  setTimeout(async () => {
    socketPing(socket);
  }, process.env.NODE_ENV === 'production' ? 60000 : 10000);
};




const Main = () => {

  const portalContext = useContext(WsDeliverPortalContext);

  const currentLocation = useLocation();

  useEffect(() => {

    createEvent({
      name: 'webTelemetry',
      measurements: {
        height: window.innerHeight,
        width: window.innerWidth,
        dpr: window.devicePixelRatio
      },
      properties: {
        browser: navigator.userAgent,
        email: portalContext?.currentUser?.email,
        name: portalContext?.currentUser?.name,
        path: currentLocation.pathname,
        url: window.location.href,
        nodeEnv: process.env.NODE_ENV,
        wspEnv: process.env.REACT_APP_WSP_ENV,
        eventType: WsAnalyticsEventType.PortalNavigate
      }
    });

  }, [ currentLocation ]);

  // Routing
  return (
    <div className="container is-widescreen">

      {/* <div className="wsp-announcement-message">
        <MessageBar
          onDismiss={() => {
            // const hide = [ ...hideAnnouncements ];
            // hide.push('2023-12-13-2');
            // setHideAnnouncements(hide);
          }}
          dismissButtonAriaLabel="Close"
          messageBarType={MessageBarType.warning}
          messageBarIconProps={{ iconName: 'Warning12' }}
        >
          <b>INFO (2024-10-10):</b> MSFT Sandbox temporarily unavailable!
        </MessageBar>
      </div> */}

      <Switch>

        {/* TODO: fix routes */}
        {/* When setting up new routes, make sure to order them from the most specific first to the more generic last (e.g. "/" is the most generic of them all as all routes include a slash) */}

        <Route path={`/deliver/config/:tenantType/:tenantId`} component={WsConfigPage} />
        <Route path={`/deliver/config/:tenantType`}           component={WsConfigPage} />
        <Route path={`/deliver/config`}                       component={WsConfigPage} />

        <Route path={`/deliver/decode/databreakdown`} component={WsDataBreakdownPage} />
        <Route path={`/deliver/decode/dynamic360`}    component={WsDynamic360Page} />




        <Route path={`/deliver/decode`}  component={WsDecodePage} />

        <Route path={`/deliver/apps`}    exact component={WsAppsPage} />

        <Route path={`/deliver/ai`}      component={WsAiHubPage} />

        <Route path={`/deliver/copilot`} component={WsCopilotPage} />

        <Route path={`/deliver/aida`}    component={WsAidaPage} />

        {/* <Route path={`/deliver/aida`}>
          <div className="eg-content">
            <div className="ws-sales-solution ws-sales-solution-list ws-sales-documentation-page">
              <div className="ws-sales-admin-header">
                <Text key={'ws-sales-clients'} variant={'xLarge'} nowrap block>
                  {'AIDA'}
                </Text>
              </div>
              <hr />
              <br />
              <Shimmer />
              <br />
              <Shimmer width="80%" />
              <br />
              <Shimmer width="60%" />
              <br />
              <Shimmer width="40%" />
              <br />
        
              <br />
            </div>
          </div>
        </Route> */}

        <Route path={`/deliver/documentation`}>
          <div className="eg-content">
            <WsDocumentationPage />
          </div>
        </Route>

        {/* <div className="ws-sales-solution ws-sales-solution-list">

          <br />

          <div style={{ textAlign: 'center', paddingTop: '100px' }}>
            <PiArrowsClockwiseBold style={{ fontSize: '64px' }} /><br />
            <b>Rebuilding Content Table</b>
          </div>

          <hr />

          <Loading /> */}

          {/* <div className="ws-sales-admin-header">
            <Text key={'ws-sales-clients'} variant={'xLarge'} nowrap block>
              {'Documentation'}
            </Text>
          </div>

          <hr />

          <MarkdownPreview
            source={wiki}
            wrapperElement={{
              "data-color-mode": "light"
            }}
          /> */}
        {/* </div>
        </Route> */}




        <Route exact path={'/deliver/servicing'}       component={WsServicingPage} />

        <Route exact path="/deliver/servicing/evaluate/applications">
          servicing/evaluate/applications
        </Route>




        <Route path="/error"   component={ErrorPage} />

        {/* <Route path={`/`}            exact component={WsHomePage} />  */}

        {/* <Route path="/loading" component={Loading} /> */}

        <Redirect from="*" to="/deliver/decode" />

      </Switch>
    </div>
  );
};













const showSuccess = ({ text }: any) => toast.success(text, {
  containerId: 'notify-alert'
});

const showError = ({ text }: any) => toast.error(text, {
  containerId: 'notify-error'
});




const WsDeliverPortal = () => {

  const appContext = useContext(WsAppContext);

  const [ currentUser, setCurrentUser ] = useState<any>(undefined);

  const [ socketClient, setSocketClient ] = useState<SocketIOClient.Socket>(getSocketClient());

  const [ alert, setAlert ] = useState<WsAlert | undefined>(undefined);

  const [ jobPanelVisible, setJobPanelVisible ] = useState<number>(0);





  const showBackgroundJob = ({ text, text2, id, progress, jobId, updateOrCreate }: { text: string, text2: string, id: string, progress: number, jobId: number, updateOrCreate?: boolean }) => {
    // console.log('showBackgroundJob');

    // const urlElement = url ? <a className="ws-background-job-link" href={url} target="_blank">Open AEP</a> : <></>;

    const content = (
      text2
      ?
      <>
        <div className="ws-background-job-text">{text}</div><div className="ws-background-job-text2">{text2}</div>
        {/* {urlElement} */}
      </>
      :
      <>
        <div className="ws-background-job-text">{text}</div>
        {/* {urlElement} */}
      </>
    );



    if (updateOrCreate && toast.isActive(id)) {

      // console.log(`update : ${id}`);

      toast.update(id, {
        render: content,
        containerId: 'background-job',
        isLoading: progress < 1 ? true : false,
        progress:  progress < 1 ? progress : 0.9999999,
        type: progress < 1 ? toast.TYPE.INFO : toast.TYPE.SUCCESS,
        // autoClose: 5000
        onClick: () => {
          setJobPanelVisible(jobId);
        }
      });

    } else if (progress < 1) {

      // console.log(`create : ${id}`);

      const toastId = toast.info(content, {
        toastId: id,
        containerId: 'background-job',
        isLoading: progress < 1 ? true : false,
        progress:  progress < 1 ? progress : 0.9999999,
        // type: toast.TYPE.INFO,
        autoClose: false,
        closeButton: true,
        onClick: () => {
          setJobPanelVisible(jobId);
        }
      });

      // console.log(toastId);

      // setTimeout(() => {
        
      //   console.log('update');

      //   toast.update(toastId, {
      //     render: "New content",
      //     type: toast.TYPE.INFO,
      //     autoClose: 5000
      //   });

      // }, 2000);
    }
  };





  useEffect(() => {

    const loadCurrentUser = async () => {

      const currentUserResult = await http.get<any>('/v2/users/current');// TODO: move to constants

      if (currentUserResult) {

        if (currentUserResult.currentUser) {

          setAuthenticatedUser(currentUserResult.currentUser.email);

          // Capture what types of browsers and screen we need to optimise for
          createEvent({
            name: 'webTelemetry',
            measurements: {
              height: window.innerHeight,
              width: window.innerWidth,
              dpr: window.devicePixelRatio
            },
            properties: {
              browser: navigator.userAgent,
              email: currentUserResult.currentUser && currentUserResult.currentUser.email,
              name: currentUserResult.currentUser && currentUserResult.currentUser.name,
              path: window.location.pathname,
              url: window.location.href,
              nodeEnv: process.env.NODE_ENV,
              wspEnv: process.env.REACT_APP_WSP_ENV,
              eventType: WsAnalyticsEventType.PortalLoad
            }
          });
    
          setCurrentUser(currentUserResult.currentUser);

          socketClientCurrentUser = currentUserResult.currentUser;

        } else {

          // Refresh to try and get the current user
          setTimeout(() => {
            window.location.replace(`${window.location.href.split('?')[0]}?t=${(new Date()).getTime()}`);
          }, 1000);
        }

      } else {

        setAlert({
          text: 'Portal requires a reload!',
          buttons: {
            reload: true
          }
        });
      }
    };

    loadCurrentUser();

    socketClient.on('wsp:alert', async (data: any) => {
      // console.log('alert', data);

      if (data && data.text) {
        setAlert(data);
      }
    });

    socketClient.on('wsp:ping', async (data: any) => {
      console.log('ping');
    });

    socketPing(socketClient);

  }, []);





  // socket wsp:job

  useEffect(() => {

    const socketClientLoading = async (data: any) => {

      if (data && data.trace && data.jobItem) {

        // if (process.env.NODE_ENV === 'development') {
        //   console.log('socket data');
        //   console.log(data);
        // }

        // const jobItem: WsDeliverJobInterface = data.jobItem;

        const text = getJobTitle(data.jobItem);

        const text2 = getJobStatus(data.jobItem);

        if (currentUser) {
          // console.log('currentUser');

          if (currentUser.email === data.jobItem.data.ownerEmail) {
            // console.log(`job for me!`);

            showBackgroundJob({
              text,
              text2,
              id: data.trace,
              progress: data.progress,
              jobId: data.jobItem.id || 0,
              updateOrCreate: true
            });
          }
        }
      }
    };

    socketClient.on('wsp:job', socketClientLoading);

    return () => {
      socketClient.off('wsp:job', socketClientLoading);
    };

  }, [ currentUser ]);




  
  if (currentUser) {

    return (
      <WsDeliverPortalContext.Provider
        value={{
          currentUser,
          socketClient,
          setAlert,
          setJobPanelVisible,
          showBackgroundJob
        }}
      >

        <MantineProvider
          withGlobalStyles
          withNormalizeCSS
          theme={{
            colors: {
              avanade: [
                '#fff4e6',
                '#ffe8cc',
                '#ffd8a8',
                '#ffc078',
                '#ffa94d',
                '#ff922b',
                '#fd7e14',
                '#f76707',
                '#e8590c',
                '#d9480f'
              ],
              nestle: [
                '#f7f5f2',
                '#e9e8e7',
                '#d4cfc9',
                '#beb4a8',
                '#ac9d8c',
                '#a18e7a',
                '#9d876f',
                '#89745e',
                '#7a6751',
                '#63513d'
              ],
              swedbank: [
                "#ffefe3",
                "#ffdecc",
                "#ffba9b",
                "#ff9564",
                "#fe7537",
                "#fe611a",
                "#fb4f00",
                "#e44700",
                "#cb3d00",
                "#b23100"
              ],
            },
            primaryColor: 'swedbank'
          }}
        >

          <BrowserRouter basename="/v1">

            <Fragment>

              <WsHeader
                history={{}}
                location={{}}
                servicingVersionNumber={''}
                currentUser={currentUser}
                theme={appContext?.theme}
                setTheme={appContext?.setTheme}
                role={appContext?.role}
                setRole={appContext?.setRole}
                logout={() => {}}
                setSearchResults={() => {}}
              >
                <WsHeaderAdmin />
              </WsHeader>

              <Main />

              <WsAlertComponent alert={alert} setAlert={setAlert} />

              <ToastContainer
                containerId={'background-job'}
                theme="light"
                hideProgressBar={false}
                closeOnClick={false}
                enableMultiContainer={true}
                autoClose={false}
                draggable={false}
                position={toast.POSITION.BOTTOM_LEFT}
                closeButton={false}
              />

              {
                jobPanelVisible !== 0
                &&
                <WsJobPanel
                  jobId={jobPanelVisible}
                  closePanel={() => {
                    setJobPanelVisible(0);
                  }}
                />
              }

            </Fragment>

          </BrowserRouter>

        </MantineProvider>

      </WsDeliverPortalContext.Provider>
    );

  } else {

    return (
      <>
        <Loading />
        <WsAlertComponent alert={alert} setAlert={setAlert} />
      </>
    );
  }
};




export {
  WsDeliverPortal
};
